import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Container from 'components/Container';
import { SxProps, Theme } from '@mui/material';

const styles = {
  title: {
    fontWeight: 700,
  } as const,
  subTitle: {
    fontSize: '26px',
    fontWeight: 700,
  } as const,
  buttonWrapper: {
    marginTop: 4,
  } as const,
} as const;

interface CtaSimpleCenteredProps {
  title?: string;
  subTitle?: string;
  buttonText?: string;
  buttonLink?: string;
  titleSx?: SxProps<Theme>;
  subTitleSx?: SxProps<Theme>;
  buttonSx?: SxProps<Theme>;
}

const CtaSimpleCentered = ({
  title,
  subTitle,
  buttonText = '了解更多',
  buttonLink = '/book-demo',
  titleSx,
  subTitleSx,
  buttonSx,
}: CtaSimpleCenteredProps): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Container>
      <Box>
        {title && (
          <Typography
            variant="h3"
            color="text.primary"
            align={'center'}
            gutterBottom
            sx={{ ...styles.title, ...titleSx }}
          >
            {title}
          </Typography>
        )}
        {subTitle && (
          <Typography
            component="p"
            align={'center'}
            sx={{ ...styles.subTitle, ...subTitleSx }}
          >
            {subTitle}
          </Typography>
        )}
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretched', sm: 'flex-start' }}
          justifyContent={'center'}
          sx={styles.buttonWrapper}
        >
          <Button
            component={'a'}
            variant="contained"
            color="primary"
            size="large"
            fullWidth={!isMd}
            href={buttonLink}
            sx={buttonSx}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default memo(CtaSimpleCentered);
